// NOTE: Converts a Date to backend format YYYY-MM-DDTHH:mm:ss+HH:mm for Polish timezone. To pass Europe/Warsaw timezone to backend, can't use to ISOString() because it returns UTC time, can't use formatDate() because it needs to import registerLocaleData

export function convertDateToISO8601Format(value: Date, locale: string = "pl-PL", timeZone: string = "Europe/Warsaw"): string {
    const localDateTimeFormatter = new Intl.DateTimeFormat(locale, {
        timeZone: "UTC",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hourCycle: "h23",
    });
    const polishTimeZoneFormatter = new Intl.DateTimeFormat(locale, {
        timeZone,
        timeZoneName: "longOffset",
    });

    const parts = localDateTimeFormatter
        .formatToParts(value)
        .reduce<Record<string, string>>((result, part) => ({ ...result, [part.type]: part.value }), {});
    const timeZoneParts = polishTimeZoneFormatter
        .formatToParts(value)
        .reduce<Record<string, string>>((result, part) => ({ ...result, [part.type]: part.value }), {});
    const timeZoneOffset = timeZoneParts.timeZoneName.replace("GMT", "");

    return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}${timeZoneOffset}`;
}
